var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91065 6.73935L6.33398 2.66602C6.33398 2.4008 6.43934 2.14645 6.62688 1.95891C6.81441 1.77137 7.06877 1.66602 7.33398 1.66602C8.13065 1.66602 9.73065 3.03602 9.40732 4.96935L9.10732 6.75602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.6663C12.2348 15.6663 15.6673 12.2339 15.6673 7.99967C15.6673 3.76549 12.2348 0.333008 8.00065 0.333008C3.76647 0.333008 0.333984 3.76549 0.333984 7.99967C0.333984 12.2339 3.76647 15.6663 8.00065 15.6663Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 9.66634C8.92113 9.66634 9.66732 8.92015 9.66732 7.99967C9.66732 7.0792 8.92113 6.33301 8.00065 6.33301C7.08018 6.33301 6.33398 7.0792 6.33398 7.99967C6.33398 8.92015 7.08018 9.66634 8.00065 9.66634Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91016 5.50674C3.25178 4.81059 3.73236 4.19177 4.32226 3.68843C4.91217 3.18508 5.59891 2.80789 6.34016 2.58008",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67383 5.22331C5.16127 4.63667 5.79647 4.19076 6.51383 3.93164",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26081 6.90967L13.3341 6.33301C13.5994 6.33301 13.8537 6.43836 14.0412 6.6259C14.2288 6.81344 14.3341 7.06779 14.3341 7.33301C14.3341 8.12967 12.9641 9.72967 11.0308 9.40634L9.24414 9.10634",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4941 2.91016C11.1903 3.25178 11.8091 3.73236 12.3125 4.32226C12.8158 4.91217 13.193 5.59891 13.4208 6.34016",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 4.67285C11.364 5.1603 11.8099 5.79549 12.069 6.51285",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09 9.25983L9.66667 13.3332C9.66667 13.5984 9.56131 13.8527 9.37377 14.0403C9.18624 14.2278 8.93188 14.3332 8.66667 14.3332C7.87 14.3332 6.27 12.9632 6.59333 11.0298L6.89333 9.24316",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0902 10.4932C12.7485 11.1893 12.268 11.8081 11.678 12.3115C11.0881 12.8148 10.4014 13.192 9.66016 13.4198",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3263 10.7764C10.8389 11.363 10.2037 11.8089 9.48633 12.068",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73935 9.09L2.66602 9.66667C2.4008 9.66667 2.14645 9.56131 1.95891 9.37377C1.77137 9.18624 1.66602 8.93188 1.66602 8.66667C1.66602 7.87 3.03602 6.27 4.96935 6.59333L6.75602 6.89333",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50674 13.0902C4.81059 12.7485 4.19177 12.268 3.68843 11.678C3.18508 11.0881 2.80789 10.4014 2.58008 9.66016",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22331 11.3263C4.63667 10.8389 4.19076 10.2037 3.93164 9.48633",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFan);
export default __webpack_public_path__ + "static/media/closeFan.f9e7978b.svg";
export { ForwardRef as ReactComponent };